import axios from 'axios'

export default {
  request (method, uri, data = null, params = null, headers = null) {
    if (!method) {
      console.error('API function call requires method argument')
      return
    }

    if (!uri) {
      console.error('API function call requires uri argument')
      return
    }

    if (window.localStorage.token) {
      headers = {'Authorization': 'Bearer ' + window.localStorage.token}
    }

    var url = uri
    return axios({method, url, data, params, headers})
  },
  
  get (uri, params) {
    var method = 'get'
    var url = uri
    return axios({method, url, params})
  }
}
